<template>
    <div>
      <!-- Header Section with Animation -->
      <div class="header animate-fade-in">
        Service
      </div>
      
      <div class="container py-5">
        <div class="row p-5">
          <!-- Law and Regulation Card -->
          <div class="col-md-4 mb-4 animate-slide-up" style="animation-delay: 0.2s">
            <div class="service-card">
              <div class="img-wrapper">
                <img src="@/assets/lawandregulation.png" class="h-50" alt="Law and Regulation">
              </div>
              <div class="service-text p-3">
                <h3 class="primary-text">Law and Regulation</h3>
              </div>
            </div>
        </div>
  
          <!-- Business Matching Card -->
          <div class="col-md-4 mb-4 animate-slide-up" style="animation-delay: 0.4s">
            <div class="service-card">
              <div class="img-wrapper">
                <img src="@/assets/bissness_matching.png" class="h-50" alt="Business Matching">
              </div>
              <div class="service-text p-3">
                <h3 class="primary-text">Business Matching</h3>
              </div>
            </div>
          </div>
  
          <!-- 2CTIC Card -->
          <div class="col-md-4 mb-4 animate-slide-up" style="animation-delay: 0.6s">
            <div class="service-card">
              <div class="img-wrapper">
                <img src="@/assets/2ctic.png" class="h-50" alt="Law and Regulation">
              </div>
              <div class="service-text p-3">
                <h3 class="primary-text">2CTIC</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ServicePage'
  }
  </script>
  
  <style>
  /* Existing styles */
  .header {
    background-image: url('https://marketweb.9ood.net/assets/bg-mini-header.jpg');
    background-size: cover;
    background-position: center;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ff6f47;
    font-size: 2rem;
    font-weight: bold;
    width: 100%;
  }
  
  .service-card {
    border-radius: 15px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    overflow: hidden;
    transition: all 0.3s ease;
    background: white;
    position: relative;
    cursor: pointer;
  }
  
  /* Hover Animation for Cards */
  .service-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 8px 16px rgba(0,0,0,0.2);
  }
  
  /* Image Wrapper and Hover Effect */
  .img-wrapper {
    overflow: hidden;
    position: relative;
  }
  
  .img-wrapper img {
    width: 100%;
    height: auto;
    transition: transform 0.5s ease;
  }
  
  .service-card:hover .img-wrapper img {
    transform: scale(1.1);
  }
  
  /* Text Animation on Hover */
  .service-text {
    text-align: center;
    margin-top: 15px;
    transition: all 0.3s ease;
  }
  
  .service-card:hover .service-text {
    transform: translateY(-5px);
  }
  
  .primary-text {
    color: #013E77;
    transition: color 0.3s ease;
  }
  
  .service-card:hover .primary-text {
    color: #0B8AC6;
  }
  
  /* Entrance Animations */
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(50px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .animate-fade-in {
    animation: fadeIn 1s ease forwards;
  }
  
  .animate-slide-up {
    opacity: 0;
    animation: slideUp 0.8s ease forwards;
  }
  
  /* Shimmer Effect */
  .service-card::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      to right,
      rgba(255,255,255,0) 0%,
      rgba(255,255,255,0.3) 50%,
      rgba(255,255,255,0) 100%
    );
    transform: rotate(30deg);
    transition: all 0.8s;
    opacity: 0;
  }
  
  .service-card:hover::after {
    animation: shimmer 1.5s infinite;
  }
  
  @keyframes shimmer {
    0% {
      transform: rotate(30deg) translateX(-100%);
      opacity: 0.1;
    }
    100% {
      transform: rotate(30deg) translateX(100%);
      opacity: 0;
    }
  }
  
  /* Responsive Animations */
  @media (max-width: 768px) {
    .service-card:hover {
      transform: translateY(-5px);
    }
    
    .animate-slide-up {
      animation-delay: 0.2s !important;
    }
  }
  </style>